import React, { useRef } from 'react'
import { useState, useContext, useMemo, useEffect } from 'react';
import { Context } from '../../App';
import { useNavigate, useLocation } from 'react-router-dom';
import { db } from '../../config/firebase'
import ReactGA from "react-ga4";
import {
  getDocs,
  collection,
  query,
  where,
  orderBy,
  limit,
  arrayUnion,
  doc,
  getDoc,
  setDoc,
  Timestamp,
  updateDoc,
} from "firebase/firestore";

import { FaLeftRight } from "react-icons/fa6";
import { FiSearch } from "react-icons/fi";
import { SiTicktick } from "react-icons/si";

import Spinner from '../../components/Loading/TailSpin';
import MultiselectDropdown from '../../components/Dropdown/Multiselect';
import PopupAnimation from '../../components/animations/PopupAnimation';
import Checkbox from '../../components/Input/Checkbox';
import ModalAnimation from '../../components/animations/ModalAnimation';


function AddIndividuals({ }) {
  const navigate = useNavigate();

  const {
    generatedCodeC,
    nameC, } = useContext(Context);

  const [addingStatus, setAddingStatus] = useState(0);
  const [generatedCode, setGeneratedQrCode] = generatedCodeC
  const [name, setName] = nameC;
  const [desc, setDesc] = useState("");
  const [password, setPassword] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [isAddGroupOpen, setIsAddGroupOpen] = useState(false);
  const [leftUsersSearch, setLeftUsersSearch] = useState("")
  const [rightUsersSearch, setRightUsersSearch] = useState("")

  const [showSuccessPop, setShowSuccessPop] = useState(false);
  const successRef = useRef(null);

  const [leftUsersList, setLeftUsersList] = useState([])
  const [rightUsersList, setRightUsersList] = useState([]);
  const [connectionFrom, setConnectionFrom] = useState(null)


  // ===================| MAIN PUSH |=================================================
  const handleAddGroup = async () => {
    setIsLoading(true);


    try {

      for (const rightUser of rightUsersList.filter((item) => item.selected)) {

        let generatedGroupId = "";
        for (let i = 0; i < 9; i++) {
          generatedGroupId += ('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'.charAt(Math.floor(Math.random() * 62)))
        }
        const enteredData = {
          name: "INDIVIDUAL",
          desc: "INDIVIDUAL",
          createdAt: Timestamp.now(),
          isIndividual: true,
          users: [{ uid: rightUser.id, displayName: rightUser.displayName }, { uid: connectionFrom.id, displayName: connectionFrom.displayName }],
          // user1Id: rightUser.id,
          // user1DisplayName: rightUser.displayName,
          // user2Id: connectionFrom.id,
          // user2DisplayName: connectionFrom.id,
        }
        // console.log(enteredData);

        // -------------------------------------------------------------------------
        const userDocRef = doc(db, 'users', rightUser.id);
        const docSnap = await getDoc(userDocRef);

        if (docSnap.exists()) {
          // console.log("Adding" + user.name + "to Group");
          console.log(docSnap.data().groups);
          if (docSnap.data().groups.find((item) => item.name === connectionFrom.displayName)) {
            // console.log("IND already exits");
            setIsLoading(false)
            return
          }
          await updateDoc(userDocRef, {
            groups: arrayUnion({ name: connectionFrom.displayName, groupId: generatedGroupId, isPinned: false, isIndividual: true })
          });
        }

        // -------------------------------------------------------------------------
        const leftUserDocRef = doc(db, 'users', connectionFrom.id);
        const docLeftUserSnap = await getDoc(leftUserDocRef);

        if (docLeftUserSnap.exists()) {
          // console.log("Adding" + user.name + "to Group");
          await updateDoc(leftUserDocRef, {
            groups: arrayUnion({ name: rightUser.displayName, groupId: generatedGroupId, isPinned: false, isIndividual: true })
          });
        }

        // -------------------------------------------------------------------------
        const newGrpRef = doc(db, 'groups', generatedGroupId);
        await setDoc(newGrpRef, enteredData);
      }

      setShowSuccessPop(true);
      setLeftUsersList((prev) => prev.map((item) => ({...item, selected:false})))
      setRightUsersList((prev) => prev.map((item) => ({...item, selected:false})))
      setLeftUsersSearch("")
      setRightUsersSearch("")

      ReactGA.event({
        category: "Admin",
        action: "Add Individuals",
        label: localStorage.getItem("displayName"),
      });

    } catch (error) {
      console.error("Error adding document: ", error);
    }
    setIsLoading(false)
  };

  useEffect(() => {

    const getUsersList = async (id) => {
      setIsLoading(true)
      try {
        const collectionRef = collection(db, 'users')

        let q = query(collectionRef, where("accessStatus", "==", 1), orderBy("name"), limit(100));

        const data = await getDocs(q);
        const reqData = data.docs.map((item) => ({
          ...item.data(),
          id: item.id,
          selected: false
        }))
        // .filter((item) => (item.accessStatus === 1))

        setLeftUsersList(reqData);
        setRightUsersList(reqData);
        // setInvestorsMemo(reqData);
        // console.log(reqData);
      } catch (error) {
        console.log(error);
      }
      setIsLoading(false)
    }

    getUsersList();

    ReactGA.send({ hitType: "pageview", page: "GURU/add-group", title: "Add Group" })
  }, [])

  const handleSingleIndvSelection = (id, setLeftUsersList, setConnectionFrom) => {
    // console.log(id);
    setLeftUsersList((prev) => {
      let prevCopy = prev;

      return prev.map((item) => {
        if (item.id === id) {
          setConnectionFrom(item)
          // setRightUsersList((prev) => prev)
          return {
            ...item, selected: true
          }
        }
        else return {
          ...item, selected: false
        }
      })
    }
    )
  }
  const handleMultipleIndvSelection = (id, setRightUsersList) => {
    // console.log(id);
    setRightUsersList((prev) => prev.map((item) => {
      if (item.id === id) return {
        ...item, selected: !item.selected
      }
      return item
    }
    ))
  }

  if (!isLoading)
    return (
      <div className='w-full h-full flex flex-col items-center justify-center p-6'>

        <div className="w-full md:w-[420px] lg:w-[820px] h-full p-4 md:p-6  bg-lightPrimary flex flex-col items-center rounded-lg ">
          <div className="text-2xl md:text-3xl font-semibold text-headPrimary md:leading-7">Add Individual Chats</div>

          <div className="w-full h-[calc(100%-300px)] md:h-[calc(100%-120px)] flex justify-between gap-4 mt-5 md:mt-7">

            {/* ------------------------------------------| LEFT SIDE |----------------------------------- */}
            <div className="w-[200px] flex flex-col">
              <div className="flex items-center p-1 border bg-headPrimary rounded-t-md ">
                <div className="border border-gray-300 bg-white text-gray-700 z-1 flex h-[30px] md:h-[28px] w-[150px] flex-grow items-left justify-start gap-2 rounded-md px-1.5 py-0.5">
                  <div className="flex h-full w-full items-center font-normal ">
                    <FiSearch
                      className="h-3 w-3 text-gray-400 hover:text-headPrimary cursor-pointer dark:text-white" />
                    <input
                      onChange={(e) => {
                        setLeftUsersSearch((e.target.value))
                      }}
                      value={leftUsersSearch}
                      type="text"
                      placeholder="Search for User"
                      className="block ml-0 px-2 h-auto w-full bg-white text-sm text-gray-700 outline-none placeholder:!text-gray-400"
                    />
                  </div>
                </div>
              </div>

              <div className="grow-0 w-full max-h-[calc(100%-38px)] overflow-y-auto py-0 grid grid-cols-1 border-b border-l border-r">

                {leftUsersList
                  .filter((item) => (item.name?.toLowerCase().includes(leftUsersSearch.toLowerCase())))
                  .map((item, ind) => (
                    <label htmlFor={item.id + "leftList"}
                      // onClick={() => (handleMultipleIndvSelection(item.name))}
                      key={item.id + "leftList"} className={`flex w-full items-center ${item.selected ? "font-semibold" : ""} hover:font-bold ${ind % 2 ? "bg-gray-50" : "bg-white"} py-1 px-2 cursor-pointer group`}>

                      <Checkbox
                        checked={item.selected}
                        onChange={() => (handleSingleIndvSelection(item.id, setLeftUsersList, setConnectionFrom))}
                        id={item.id + "leftList"} />

                      <div className="ms-2 flex flex-col text-left font-normal capitalize text-sm md:text-base hover:text-gray-800 dark:text-gray-300 group-hover:font-bold">
                        <div className="">{item.name}</div>
                        <div className="text-gray-600 text-xs">{item.displayName}</div>
                      </div>
                    </label >

                  ))}
              </div>
            </div>

            {/* ------------------------------------------| CENTER SIDE (DESKTOP) |----------------------------------- */}
            <div className="hidden flex-grow h-full md:flex flex-col gap-1 p-5 bg-white rounded-md text-base overflow-y-auto border">
              {
                rightUsersList.filter((item) => item.selected).map((rightUser) => (
                  <div key={rightUser.id + "showConn"} className="flex items-center p-1.5 bg-lightPrimary border gap-2 rounded">
                    <div className="">{connectionFrom.name}</div>
                    <FaLeftRight className='w-4 h-4 text-headPrimary' />
                    <div className="">{rightUser.name}</div>
                  </div>
                ))
              }
            </div>

            {/* ------------------------------------------| RIGHT SIDE |----------------------------------- */}
            <div className="w-[200px] flex flex-col">
              <div className="flex items-center p-1 border bg-headPrimary rounded-t-md ">
                <div className="border border-gray-300 bg-white text-gray-700 z-1 flex h-[30px] md:h-[28px] w-[150px] flex-grow items-left justify-start gap-2 rounded-md px-1.5 py-0.5">
                  <div className="flex h-full w-full items-center font-normal ">
                    <FiSearch
                      className="h-3 w-3 text-gray-400 hover:text-headPrimary cursor-pointer dark:text-white" />
                    <input
                      onChange={(e) => {
                        setRightUsersSearch((e.target.value))
                      }}
                      value={rightUsersSearch}
                      type="text"
                      placeholder="Search for Users"
                      className="block ml-0 px-2 h-auto w-full bg-white text-sm text-gray-700 outline-none placeholder:!text-gray-400"
                    />
                  </div>
                </div>
              </div>

              <div className="grow-0 w-full max-h-[calc(100%-38px)] overflow-y-auto py-0 grid grid-cols-1 border-b border-l border-r">

                {rightUsersList
                  .filter((rightUser) => rightUser.id !== connectionFrom?.id)
                  .filter((item) => (item.name.toLowerCase().includes(rightUsersSearch.toLowerCase())))
                  .map((item, ind) => (
                    <label htmlFor={item.id + "rightList"}
                      // onClick={() => (handleMultipleIndvSelection(item.name))}
                      key={item.id + "rightList"} className={`flex w-full items-center ${item.selected ? "font-semibold" : ""} hover:font-bold ${ind % 2 ? "bg-gray-50" : "bg-white"} py-1 px-2 cursor-pointer group`}>

                      <Checkbox
                        checked={item.selected}
                        onChange={() => (handleMultipleIndvSelection(item.id, setRightUsersList))}
                        id={item.id + "rightList"} />

                      <div className="ms-2 flex flex-col text-left font-normal capitalize text-sm md:text-base hover:text-gray-800 dark:text-gray-300 group-hover:font-bold">
                        <div className="">{item.name}</div>
                        <div className="text-gray-600 text-xs">{item.displayName}</div>
                      </div>
                    </label >

                  ))}
              </div>
            </div>

          </div>


          {/* ------------------------------------------| CENTER SIDE (MOBILE) |----------------------------------- */}
          <div className="mt-5 w-full h-[155px] md:hidden p-3 bg-white rounded-md text-base overflow-y-auto">
            <div className="w-full max-h-full grid grid-cols-2 gap-2 overflow-y-auto">
              {
                rightUsersList.filter((item) => item.selected).map((rightUser) => (
                  <div key={rightUser.id + "showConn"} className="flex items-center p-1.5 bg-lightPrimary border gap-2 rounded">
                    <div className="">{connectionFrom.name}</div>
                    <FaLeftRight className='w-4 h-4 text-headPrimary' />
                    <div className="">{rightUser.name}</div>
                  </div>
                ))
              }
            </div>
          </div>


          <button
            onClick={handleAddGroup}
            disabled={!connectionFrom}
            className={`mt-6 flex items-center justify-center py-2 w-[230px] rounded-md border border-gray-300  
                      ${!connectionFrom ? "bg-gray-200 text-gray-600" : "hover:text-white hover:bg-headPrimary shadow-md hover:shadow-lg hover:font-bold bg-white text-headPrimary"} text-xl `}>
            {/* <button
              onClick={handleAddGroup}
              className=" mt-6 flex items-center justify-center py-2 w-[230px] bg-white rounded-md border text-xl text-headPrimary hover:text-white hover:bg-headPrimary shadow-md hover:shadow-lg hover:font-bold"> */}
            Create Individual Chats
          </button>

        </div>


        <ModalAnimation showDiv={showSuccessPop} >
          <div ref={successRef} className="relative flex w-[290px] h-fit flex-col items-center p-5 tracking-wide rounded-xl bg-white outline-none dark:bg-navy-800 focus:outline-none">


            <div className="rounded-full bg-[#5ec393] w-12 h-12 p-2.5">
              <SiTicktick className='h-full w-full text-white' />
            </div>

            <div className="text-xl font-bold text-center mt-4">
              Success
            </div>

            <div className="text-base text-center text-gray-700 mt-1">
              Individual Chats Created Successfully
            </div>

            <button
              onClick={() => { setShowSuccessPop(false) }}
              className="text-base font-bold bg-lightPrimary hover:text-white hover:bg-headPrimary px-5 py-2 rounded-md cursor-pointer mt-6">
              Continue
            </button>
          </div>
        </ModalAnimation>
      </div>
    )

  else return (<Spinner />)
}

export default AddIndividuals